import { Module } from 'vuex';
import { IRootState } from '@types';

import { ContractModel } from '@model';

import Env from '@lib/Env';

import { AContractApi } from '@/api';

const store: Module<any, IRootState> = {
    state: {
        contracts: <ContractModel[]>[],
        contractPaginator: {
            currentPage: 1,
            total: 1,
        },
        template: null,
        contractDetail: <ContractModel>null,
    },

    mutations: {
        setContractTemplate: (state, template: string) => (state.template = template),
        setContracts: (state, records: ContractModel[]) => (state.contracts = records),
        setContractDetail: (state, record: ContractModel) => (state.contractDetail = record),
        setContractPaginator: (state, paginator: any) => (state.contractPaginator = paginator),
    },

    getters: {
        getContractTemplate: (state): string => state.template,
        getContractList: (state): ContractModel[] => state.contracts,
        getContractDetail: (state): ContractModel => state.contractDetail,
        getContractPaginator: (state): any => state.contractPaginator,
    },

    actions: {
        async loadCurrentContractTemplate({ commit }): Promise<string> {
            const { data } = await AContractApi.loadCurrentContractTemplate();
            commit('setContractTemplate', data.template);
            return data;
        },

        async storeContractTemplate({ commit }): Promise<string> {
            const { data } = await AContractApi.storeContractTemplate({
                template: this.getters.getContractTemplate,
            });
            return data;
        },

        async removeContract({ commit }, id: number): Promise<void> {
            return AContractApi.removeContract(id);
        },

        async submitContract({ commit }, id: number): Promise<void> {
            return AContractApi.submitContract(id);
        },

        loadContractDetail({ commit, getters }, id: number): Promise<string> {
            return new Promise((resolve, reject) => {
                AContractApi.loadContract({
                    id: id,
                })
                    .then((response: any) => {
                        if (response.data.status) {
                            let record = response.data.record;
                            record['sent'] = response.data.record['poslana_zmluva'];
                            record['date'] = response.data.record['datum'];
                            commit('setContractDetail', new ContractModel(record));
                        }
                        resolve(response.data.status);
                    })
                    .catch((err: any) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        storeContractDetail({ commit, getters }): Promise<string> {
            return new Promise((resolve, reject) => {
                AContractApi.storeContractDetail({
                    id: this.getters.getContractDetail.id,
                    text: this.getters.getContractDetail.text,
                })
                    .then((response: any) => {
                        resolve(response.data && response.data.status);
                    })
                    .catch((err: any) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        loadContractList({ commit, getters }, filter): Promise<ContractModel[]> {
            return new Promise((resolve, reject) => {
                AContractApi.loadContractList(filter)
                    .then((response: any) => {
                        const records = [];

                        if (response.data.records) {
                            for (let i in response.data.records) {
                                response.data.records[i].number = response.data.records[i].cislo;
                                response.data.records[i].date = response.data.records[i].datum;
                                response.data.records[i].sent = response.data.records[i].poslana_zmluva;

                                records.push(new ContractModel(response.data.records[i]));
                            }
                        }

                        commit('setContracts', records);
                        resolve(records);
                    })
                    .catch((err: any) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },
    },
};

export default store;
